import { useStoreState } from 'easy-peasy'
import type { Moment } from 'moment'
import React, { createContext, useContext, useState } from 'react'

type CalendarContextType = {
  user: any
  viewCurrentStart: Moment | null
  setViewCurrentStart: (start: Moment | null) => void
  viewCurrentEnd: Moment | null
  setViewCurrentEnd: (end: Moment | null) => void
}

export const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined
)

export const CalendarProvider = ({
  children
}: {
  children: React.ReactNode
}) => {
  const { user } = useStoreState((state: any) => state.auth)
  const [viewCurrentStart, setViewCurrentStart] = useState<Moment | null>(null)
  const [viewCurrentEnd, setViewCurrentEnd] = useState<Moment | null>(null)

  return (
    <CalendarContext.Provider
      value={{
        user,
        viewCurrentStart,
        setViewCurrentStart,
        viewCurrentEnd,
        setViewCurrentEnd
      }}
    >
      {children}
    </CalendarContext.Provider>
  )
}

export const useCalendar = () => {
  const context = useContext(CalendarContext)
  if (!context) {
    throw new Error('useCalendar must be used within a CalendarProvider')
  }
  return context
}
